import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_BUSINESS_ENTITIES } from '@/lib/constants/api'
import getBusinessEntityModel from './models/businessEntity'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const businessEntity = {
  namespaced: true,
  state: {
    ...getBusinessEntityModel()
  },
  getters: {
    getField,
    getBusinessEntityObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    updateStatus,
    clearBusinessEntity: (state) => {
      state.id = null
      state.businessEntityName = null
      state.createdBy = null
      state.updatedBy = null
    },
    setBusinessEntity: (state, businessEntity) => {
      state.id = businessEntity.id
      state.businessEntityName = businessEntity.businessEntityName
      state.createdBy = businessEntity.createdBy
      state.updatedBy = businessEntity.updatedBy
    }
  },
  actions: {
    save ({ state }) {
      return api.doPost({ path: PATH_BUSINESS_ENTITIES, data: state })
    },
    update ({ state }) {
      return api.doPut({ path: PATH_BUSINESS_ENTITIES, data: state })
    },
    getBusinessEntity: ({ commit, dispatch }, { id }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting business entity, please wait...' })

      return api.doGet({ path: `${PATH_BUSINESS_ENTITIES}/${id}`, parameters: { id } })
        .then(json => json.data)
        .then(data => Array.isArray(data) ? data[0] : data)
        .then(businessEntity => {
          commit('updateStatus', { status: COMPLETE })
          commit('setBusinessEntity', businessEntity)
          return businessEntity
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveBusinessEntity: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving business entity, please wait...' })

      const actionName = state.id ? 'update' : 'save'

      return dispatch(actionName).then(response => {
        commit('updateStatus', { status: COMPLETE })

        if (!response.data) {
          throw new Error('Unable to save business entity. Check required fields.')
        }

        commit('clearBusinessEntity')
        notifySuccess(dispatch, 'Business entity saved')
        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        notifyError(dispatch, 'Unable to save business entity. Try again later')

        throw error
      })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    deleteBusinessEntity ({ commit, dispatch }, id = null) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Deleting business entity, please wait...' })

      return api.doDelete({ path: `${PATH_BUSINESS_ENTITIES}/${id}` })
        .then(response => {
          if (!response.data) {
            throw new Error('Unable to delete business entity')
          }

          commit('updateStatus', { status: COMPLETE })
          notifySuccess(dispatch, 'Business entity deleted')
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to delete business entity')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    clearBusinessEntity: ({ commit }) => {
      commit('clearBusinessEntity')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default businessEntity
